module.exports = __webpack_public_path__ + "img/MiddleSide_Left.6e6969f4.png";